<template>
  <div id="lay_content_all">

    <lay-left></lay-left>
    <div class="lay_content_all">
<!--      <keep-alive :include="keepAlive">-->
<!--      <router-view></router-view>-->
<!--      </keep-alive>-->
      <router-view></router-view>
    </div>
    <transition  name="slide-down">
      <bg-music v-if="showBgmusic"></bg-music>
    </transition>



    <lay-right></lay-right>
  </div>
</template>
<script>
export default {
  computed:{
    // 背景音乐显示
    showBgmusic() {
      return this.$store.getters.showBgmusic
    },
  },
  data(){
    return{
      keepAlive:[]
    }
  },
  methods:{

  },
  created() {
  }
}
</script>
<style lang="less">
#lay_content_all {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  .lay_content_all {
    width: calc(100% - 172px);
    height: 100%;
  }
}
</style>
